<template>
    <rkm-modal
        :loading="loading"
        title="Já existe um cadastro com estas informações no sistema!"
        extra-large
        ref="Modal"
        @close="$emit('close')"
    >
        <List
            :cidadaos="cidadaos"
            :pacientes="pacientes"
            :usuarios="usuarios"
            :hide-cidadaos="hideCidadaos"
            :show-pacientes="showPacientes"
            :show-usuarios="showUsuarios"
            @select-cidadao="handleSelected('cidadao', $event)"
            @select-usuario="handleSelected('usuario', $event)"
            @select-paciente="handleSelected('paciente', $event)"
        />

        <template #footer>
            <rkm-button
                color="primary"
                :disabled="!!loading"
                @click.stop="$emit('continue')"
            >
                Novo cadastro com os mesmos dados
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
        handleSelected(item, data) {

            this.$emit(`select-${item}`, data)

            this.$refs.Modal.hide()
        },
    },
    props: {
        cidadaos: { type: Array, required: true },
        hideCidadaos: { type: Boolean, default: false },
        pacientes: { type: Array, required: true },
        showPacientes: { type: Boolean, default: false },
        showUsuarios: { type: Boolean, default: false },
        usuarios: { type: Array, required: true },
    }
}
</script>